import * as React from "react";
const SvgDogPark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", id: "Capa_1", x: "0px", y: "0px", viewBox: "0 0 512 512", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M64.364,399.389c-5.312,4.36-9.593,9.91-12.213,16.234c-2.086,5.039-3.004,10.229-2.79,15.41c-0.491-0.021-0.97-0.029-1.432-0.029\n		c-21.97,0-37.617,19.134-40.052,37.634c-1.159,8.802,0.429,16.257,3.716,22.417c0.908,1.702,2.655,2.735,4.584,2.735h229.447\n		c-3.423-5.195-5.243-11.677-4.197-19.62c1.9-14.441,14.114-29.376,31.263-29.376c0.361,0,0.734,0.007,1.118,0.023\n		c-0.055-1.325-0.005-2.65,0.131-3.972c-6.699-5.954-15.302-9.84-25.194-9.84c-0.464,0-0.941,0.008-1.434,0.029\n		c0.214-5.182-0.704-10.369-2.79-15.408c-5.678-13.708-19.156-23.771-34.032-25.985" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M372.09,319.709c4.476-2.489,8.39-5.775,11.436-9.744c1.118-1.456,2.234-3.143,3.253-5.073c5.661,3.596,12.27,5.52,19.533,5.52\n			c16.953,0,33.233-10.719,39.592-26.067c2.056-4.967,2.961-10.083,2.75-15.191c0.485,0.021,0.957,0.029,1.412,0.029\n			c21.657,0,37.082-18.862,39.482-37.099c1.317-9.994-0.961-18.226-5.253-24.775c6.021-3.145,11.044-7.938,14.615-14.127\n			c7.454-12.905,7.454-30.248,0.002-43.155c-3.574-6.191-8.599-10.986-14.62-14.131c4.292-6.551,6.57-14.783,5.253-24.777\n			c-2.4-18.237-17.825-37.099-39.48-37.099c-0.458,0-0.927,0.008-1.414,0.029c0.211-5.108-0.694-10.222-2.75-15.189\n			c-6.358-15.35-22.639-26.069-39.59-26.069c-7.263,0-13.872,1.924-19.533,5.52c-1.019-1.93-2.135-3.617-3.253-5.073\n			c-7.249-9.445-19.375-15.085-32.442-15.085c-13.067,0-25.193,5.64-32.442,15.085c-1.118,1.456-2.234,3.143-3.253,5.073\n			c-5.661-3.596-12.27-5.52-19.533-5.52c-16.953,0-33.233,10.719-39.592,26.067c-2.056,4.967-2.961,10.083-2.75,15.191\n			c-0.484-0.021-0.957-0.029-1.412-0.029c-21.657,0-37.082,18.862-39.482,37.099c-1.321,10.031,0.977,18.289,5.3,24.85\n			c-11.539,5.963-20.286,17.966-20.286,35.631c0,17.669,8.748,29.672,20.286,35.637c-4.321,6.559-6.619,14.818-5.298,24.848\n			c2.4,18.237,17.825,37.099,39.48,37.099c0.458,0,0.928-0.008,1.414-0.029c-0.211,5.108,0.694,10.222,2.75,15.189\n			c6.358,15.35,22.639,26.069,39.59,26.069c7.263,0,13.872-1.924,19.533-5.52c1.019,1.93,2.135,3.617,3.253,5.073\n			c3.874,5.048,9.15,8.996,15.21,11.59" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M333.852,189v33.019l-31.179-31.179c-4.022-4.023-10.544-4.023-14.567,0l-6.327,6.327c-4.023,4.023-4.023,10.545,0,14.567\n			l52.073,52.074v141.312c5.015-2.93,10.977-4.564,17.217-4.564c7.908,0,15.375,2.616,21.022,7.186l0,0v-184.94l48.267-48.267\n			c4.023-4.022,4.023-10.544,0-14.567l-6.327-6.327c-4.022-4.023-10.545-4.023-14.567,0l-27.372,27.372v-44.467\n			c0-5.689-4.612-10.3-10.3-10.3h-17.638c-5.689,0-10.301,4.612-10.301,10.3V154" })), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 98.102, y: 399.389, style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, width: 31.046, height: 94.458 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M51,265.893H36.925c-14.222,0-25.751,11.529-25.751,25.751v81.994c0,14.222,11.529,25.751,25.751,25.751h153.399\n			c14.222,0,25.751-11.529,25.751-25.751v-81.994c0-14.222-11.529-25.751-25.751-25.751H86" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n			M169.996,332.641c4.848-3.496,8.007-9.188,8.007-15.621c0-10.632-8.619-19.25-19.25-19.25c-10.073,0-18.334,7.738-19.175,17.594\n			H87.671c-0.841-9.855-9.102-17.594-19.175-17.594c-10.632,0-19.25,8.619-19.25,19.25c0,6.433,3.159,12.126,8.007,15.621\n			c-4.848,3.496-8.007,9.188-8.007,15.621c0,10.632,8.619,19.25,19.25,19.25c10.073,0,18.334-7.738,19.175-17.594h51.907\n			c0.841,9.855,9.102,17.594,19.175,17.594c10.632,0,19.25-8.619,19.25-19.25C178.003,341.829,174.844,336.136,169.996,332.641z" })), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M313,493.79h140.564c1.962,0,3.757-1.112,4.626-2.871c2.303-4.661,3.375-10.232,2.517-16.75\n		c-1.9-14.441-14.114-29.376-31.262-29.376c-0.362,0-0.734,0.007-1.12,0.023c0.167-4.045-0.549-8.094-2.177-12.027\n		c-5.035-12.155-17.926-20.643-31.348-20.643c-5.751,0-10.985,1.523-15.467,4.371c-0.807-1.528-1.69-2.864-2.576-4.017\n		c-5.74-7.479-15.342-11.945-25.689-11.945c-10.347,0-19.949,4.466-25.689,11.945c-0.885,1.153-1.769,2.489-2.576,4.017\n		c-4.482-2.848-9.716-4.371-15.467-4.371c-13.424,0-26.315,8.488-31.35,20.641c-1.628,3.933-2.344,7.984-2.177,12.029\n		c-0.384-0.016-0.757-0.023-1.118-0.023c-17.149,0-29.363,14.936-31.263,29.376c-1.046,7.943,0.774,14.425,4.197,19.62H278" }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 273, y1: 120, x2: 273, y2: 120 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 308, y1: 69, x2: 308, y2: 69 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 416, y1: 99, x2: 416, y2: 99 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 449, y1: 224, x2: 449, y2: 224 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 259, y1: 238, x2: 259, y2: 238 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 454, y1: 147, x2: 454, y2: 147 })));
export default SvgDogPark;
